import type { Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { overflowHyphens } from '@hrworks/design-system/utilities';

const componentConfig = (theme: Theme) => ({
  paddingBlock: theme.eclipseTier1.spacing['16px'],
  paddingInline: theme.eclipseTier1.spacing['20px'],
  borderRadius: theme.eclipseTier1.radius['8px'],
});

const Container = styled.div(({ theme }) => {
  const { paddingBlock, paddingInline, borderRadius } = componentConfig(theme);

  return [
    overflowHyphens,
    {
      paddingBlock,
      paddingInline,
      borderRadius,
      border: `solid 1px ${theme.eclipseTier2Color.border.bold}`,
      backgroundColor: theme.stellenportal?.cardStyle?.color || theme.eclipseTier2Color.surface.structure,
    },
  ];
});

export const S = {
  componentConfig,
  Container,
} as const;
